import MDBox from "../../components/MDBox";
import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { getFillTimeHistoryHistory } from "../../api/routes";
import Loading from "../../components/Loading";
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: 600,
  overflow: "auto",
  borderRadius: 4,
  p: 4,
};

function fillTimeHistoryField(field) {
  let text: string;
  switch (field) {
    case "fullname": {
      text = "نام و نام خانوادگی";
      break;
    }
    case "phoneNumber": {
      text = "تلفن همراه";
      break;
    }
    case "adminUsername": {
      text = "کاربر ثبت کننده";
      break;
    }
    case "del": {
      text = "حذف";
      break;
    }
    case "isReserved": {
      text = "پر شده";
      break;
    }
    default: {
      text = "";
      break;
    }
  }
  return text;
}


export default function FillTimeHistoryModal({ modal, handleClose }) {
  const [loading, setLoading] = useState(false);
  const [fillTimeHistory, setFillTimeHistory] = useState([]);
  useEffect(() => {
    if (modal?.item) {
      setLoading(true);
      getFillTimeHistoryHistory(modal?.item?.id, (isOk, data) => {
        setLoading(false);
        if (!isOk) {
          return toast.error(data.message);
        } else {
          setFillTimeHistory(data);
        }
      });
    }
  }, [modal?.item]);

  const columns = [
    {
      field: "fieldName",
      headerName: "فیلد",
      width: 160,
      valueGetter: (params) => fillTimeHistoryField(params.row.fieldName),
    },
    {
      field: "oldValue",
      headerName: "مقدار قبلی",
      width: 160,
    },
    {
      field: "newValue",
      headerName: "مقدار جدید",
      width: 160,
    },
    {
      field: "createdAt",
      headerName: "تاریخ ایجاد",
      width: 200,
      valueGetter: (params) => new Date(params.row.createdAt).toLocaleString("fa-IR"),
    },
  ];

  const rows = fillTimeHistory.map((item, index) => ({ index: index + 1, ...item }));

  return (
    <Modal
      open={modal.state}
      onClose={handleClose}
    >
      <MDBox sx={style}>
        <Loading loading={loading} />
        {fillTimeHistory.length > 0 && <p style={{ fontWeight: "bold", fontSize: 15, marginBottom: 10 }}>
          تاریخچه تغییرات
        </p>}
        {fillTimeHistory.length === 0 && <p>تغییراتی ثبت نشده است</p>}
        {fillTimeHistory.length > 0 && <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(item) => item.id}
          pagination={false}
          autoPageSize={false}
          hideFooter={true}
        />}
      </MDBox>
    </Modal>
  );
}
